import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { browserHistory } from 'react-router';

import Search from 'components/Search';
import globalMessages from 'components/globalMessages';
import { getGuestDirectorySearchData } from 'selectors/guestDirectory';
import { trackEvent } from 'utils/tracking';
import { StyledSearch, StyledSearchBar } from 'components/MenuSearch/styles';
import { SearchResultItem, SearchResultName, SearchResultContent, SearchResultType } from './styles';

const GuestDirectorySearch: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const searchData = useSelector(getGuestDirectorySearchData);

  const handleResultClick = (result, index) => {
    trackEvent('search', {
      search_term: searchTerm,
      category: 'guest_directory',
      item_type: result.type,
      item_id: result.id,
      item_name: result.name,
      position: index + 1,
    });

    browserHistory.push({
      pathname: result.url,
      state: { transition: 'Forward' },
    });
  };

  const renderResult = (result, index) => {
    let typeLabel;
    if (result.type === 'menu') {
      typeLabel = <FormattedMessage defaultMessage="Menu" />;
    } else if (result.type === 'section') {
      typeLabel = <FormattedMessage defaultMessage="Section" />;
    } else {
      typeLabel = <FormattedMessage defaultMessage="Content" />;
    }

    return (
      <SearchResultItem key={`${result.type}-${result.id}`} onClick={() => handleResultClick(result, index)}>
        <SearchResultName>{result.name}</SearchResultName>
        {result.content && (
          <SearchResultContent>
            {result.content.substring(0, 100)}
            {result.content.length > 100 ? '...' : ''}
          </SearchResultContent>
        )}
        <SearchResultType>{typeLabel}</SearchResultType>
      </SearchResultItem>
    );
  };

  return (
    <StyledSearch>
      <div className="u-flex u-flexAlignItemsCenter u-flexJustifyBetween">
        <StyledSearchBar>
          <Search
            searchKeys={['name', 'content']}
            searchData={searchData}
            onFocus={() => {}}
            onBlur={() => {}}
            onClear={() => {}}
            onChange={searchTerm => setSearchTerm(searchTerm)}
            filtersActive={false}
            render={renderResult}
            placeholder={globalMessages.searchGuestDirectory}
          />
        </StyledSearchBar>
      </div>
    </StyledSearch>
  );
};

export default GuestDirectorySearch;
